import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from '@phosphor-icons/react';

/**
 * Marketing footer — three-column: brand+tagline, product links, legal.
 * Deliberately minimal to keep focus on the product story above.
 */
export default function MarketingFooter() {
  return (
    <footer className="bg-[#050B18] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/vooxy-logo.svg" alt="Vooxy" className="w-8 h-8" />
              <span className="text-white font-bold text-lg" style={{ fontFamily: 'Outfit, sans-serif' }}>Vooxy</span>
            </div>
            <p className="text-slate-400 text-sm max-w-md leading-relaxed">
              The all-in-one sales & quotation OS purpose-built for manufacturing, hospitality and B2B teams that need approval hierarchy, quote-to-cash flow, and multi-region visibility — without the enterprise-CRM bloat.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Product</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-slate-400 hover:text-emerald-300 transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="text-slate-400 hover:text-emerald-300 transition-colors">Pricing</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-emerald-300 transition-colors">Book a demo</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-emerald-300 transition-colors">Migrate from Zoho</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/contact" className="text-slate-400 hover:text-emerald-300 transition-colors">Contact</Link></li>
              <li><a href="mailto:sales@vooxy.app" className="text-slate-400 hover:text-emerald-300 transition-colors">sales@vooxy.app</a></li>
              <li><span className="text-slate-500 text-xs">© {new Date().getFullYear()} Vooxy Labs</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-500">Made for teams that live in spreadsheets and want out.</p>
          <div className="flex items-center gap-6 text-xs text-slate-500">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
              All systems operational
            </div>
            {/* Discrete admin console entry — muted, small, keeps the ops link
                accessible without inviting random traffic to try it. Actual
                gate is the admin_code inside; this is just a bookmark. */}
            <a
              href="/vooxy-console"
              data-testid="footer-admin-link"
              className="inline-flex items-center gap-1.5 text-slate-600 hover:text-slate-300 transition-colors"
              title="Platform administrator sign-in"
            >
              <Lock size={11} weight="fill" />
              <span>Admin</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
